
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.105 1.948a.75.75 0 00-.75.75V12.93c0 .414.335.75.75.75h10.232a.75.75 0 00.75-.75c0-6.065-4.917-10.982-10.982-10.982zM.913 12.93c0 .414.336.75.75.75h7.442a.75.75 0 00.75-.75V5.488a.75.75 0 00-.75-.75A8.192 8.192 0 00.913 12.93zm17.523 3a.75.75 0 00-.75-.75h-5.581a.75.75 0 00-.75.75v5.582c0 .414.335.75.75.75a6.331 6.331 0 006.331-6.332zm-9.331 4.471a.75.75 0 00.75-.75v-3.72a.75.75 0 00-.75-.75H5.384a.75.75 0 00-.75.75 4.47 4.47 0 004.47 4.47z"}})])
          )
        }
      }
    